import React, { useEffect, useContext } from 'react';
import { getLogo }  from '../LocalizedPictures'
import { setNewAnswer, calculateResult, clearAllAnswer, getAllAnswer } from '../../Store'
import CountUp from 'react-countup';
import './style/Result.css'
import { useHistory } from 'react-router-dom'
import gifRresult from './assets/10_megphone 2.gif'
import '../Gif.css'
import Socials from '../Socials'
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

const Result = () => {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    console.log("calculateResult 5");
    let theNumber = calculateResult();
    let yearsNumber = theNumber * 12;
    const { translate } = useLocalize()

 
    useEffect(() => {
        if (document.querySelector('.result-box') !== null) {
            document.querySelector('.bacgroundTop').classList.add('result-page');
            document.querySelector('.question-container').classList.add('result-page');
        }
    })

    const answers = getAllAnswer();

    function sendForm() {
        var fdata = new FormData();

        //STATIC VERSION        
        fdata.append("first_name", "");
        fdata.append("last_name", "");
        fdata.append('phone', "");
        fdata.append('MailingList', "");
        fdata.append('event_type', "calc_waiting_list_registered");
        fdata.append('registered_date', new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString());
        let userEmail = localStorage.getItem("email")
        fdata.append('email', userEmail);
        fdata.append('website_origin', "He");
        fdata.append("q1", answers["1"]);
        fdata.append("q2", answers["2"]);
        fdata.append("q3", answers["3"]);
        fdata.append("q4", answers["4"]);
        fdata.append("q5", answers["5"]);
        fdata.append("q6", answers["6"]);
        fdata.append("q7", answers["7"]);
        fdata.append("q8", answers["8"]);
        fdata.append("q9", answers["9"]);
        fdata.append("q10", answers["10"]);
        fdata.append("q11", answers["11"]);
        fdata.append("q12", answers["12"]);
        fdata.append("SummaryMonth", theNumber);
        fdata.append("SummaryYear", yearsNumber);         

        var dataToSend = {};
        fdata.forEach(function (value, key) {
            dataToSend[key] = value;
        });
        var json = JSON.stringify(dataToSend);

        const requestMetadata = {
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: json
        };
 
        fetch('/api/v1/marketing/register', requestMetadata)
            .then(res => res.text())
            .then(results => {
                if(results) {
                    //history.push(`/ThankYou`);
                }
            });
        //END STATIC VERSION


        // let userEmail = localStorage.getItem("email")
        // fdata.append("fullname", '');
        // fdata.append("phone", '');
        // fdata.append("email", userEmail);
        // fdata.append("approvehidden", '');
        // fdata.append("q1", answers["1"]);
        // fdata.append("q2", answers["2"]);
        // fdata.append("q3", answers["3"]);
        // fdata.append("q4", answers["4"]);
        // fdata.append("q5", answers["5"]);
        // fdata.append("q6", answers["6"]);
        // fdata.append("q7", answers["7"]);
        // fdata.append("q8", answers["8"]);
        // fdata.append("q9", answers["9"]);
        // fdata.append("q10", answers["10"]);
        // fdata.append("q11", answers["11"]);
        // fdata.append("q12", answers["12"]);
        // fdata.append("summaryMonth", theNumber);
        // fdata.append("summaryYear", yearsNumber);
        // console.log(theNumber, yearsNumber);

        // const requestMetadata = {
        //     method: 'POST',
        //     body: fdata
        // };

        // fetch('https://www.onezerobank.com/QuizRegisterFormRegistered', requestMetadata)
        //     .then(res => res.text())
        //     .then(results => {
        //         if(results) {
        //             //history.push(`/ThankYou`);
        //         }
        //     });
    }

    return (
        <>
            {/* <div className="picHold hid vis">
                <img className="gifResult" src={gifRresult} />
            </div> */}
            <div className="result-wrapper">
                <div className="result-box">
                    <div className="reHeader">{translate('The bank probably')}<br/> {translate('charges you')} </div>
                    <div className="numAndMonth">
                        <span className="number">
                            <span className="shah">{translate('currencySybol')}</span>
                            {!settings.isAnimationPause && 
                            <CountUp separator="," start={0} end={theNumber} delay={0} duration={2.75}>
                                {({ countUpRef }) => (
                                    <span>
                                        <span ref={countUpRef} />
                                    </span>
                                )}
                            </CountUp>
                        }
                        {settings.isAnimationPause && <span>{theNumber}</span>}
                        </span>
                        <span className="month"> {translate('per month')} </span>
                        <div className="yearAndNumber">
                            <span className="ke">{translate('and about')}</span>
                            <span className="bigNumber">

                                <span>{translate('currencySybol')}</span>
                                {!settings.isAnimationPause && 
                                <CountUp separator="," start={0} end={yearsNumber} delay={0} duration={2.75}>
                                    {({ countUpRef }) => (
                                        <span>
                                            <span ref={countUpRef} />
                                        </span>
                                    )}
                                </CountUp>
                                }       
                                {settings.isAnimationPause && <span>{yearsNumber}</span>}

                            </span>
                            <span className="year">{translate('a year')}</span>
                        </div>
                    </div>
                </div>
                
            </div>
            
            
            {
                localStorage.getItem("registered") === 'true' && (
                    <div className="ThankYouText res-page">
                        {translate('At the First Digital Bank,')}
                        <br/>
                        {translate('we’re committed to ensuring you always know exactly how much the bank is charging.')}
                    </div>
                )
            }

            {
                localStorage.getItem("registered") === 'false' && (
                    <div className="ThankYouText unregistered">
                        <strong>
                            {translate('At the First Digital Bank,')}
                            <br/>
                            {translate('we’re committed to ensuring you always know exactly how much the bank is charging.')}
                       </strong>
                       <br/>
                       {translate('Join our waiting list to be one of the first')}<br/> {translate('to open an FDB account.')}
                    </div>
                )
            }

            {
                localStorage.getItem("registered") === 'false' && (
                <div 
                    className="btn" 
                    onClick={() => {
                        history.push('/Form')
                }}>
                    {translate('It only takes a moment to register >>')}
                </div>
                )
            }
            

            {
                localStorage.getItem("email") != "" && localStorage.getItem("registered")=== "true" && sendForm()
            }
            {
                /*
                    <div className="howTo">
                        <a className="linkColor" href="https://www.onezerobank.com/company/information/?ContentID=1241" target="_blank">{translate('How did we work this out?')}</a>
                    </div>
                */ 
            }
            

            <Socials page="result-page" />
            
            <div className="reslogo res">
                <img width="150" src={getLogo()} alt="" />
            </div>

        </>
    )
}



export default Result

